import { assessmentsConstants } from '../../_constants';

const initialState = { getAssessmentLoading: true, data: '', error: false };

export function getAssessmentList(state = initialState, action) {

    switch (action.type) {
        case assessmentsConstants.REQUEST_ASSESSMENT_LIST:
            return {
                getAssessmentLoading: true,
                data: '',
                error: false
            };
        case assessmentsConstants.RECEIVE_ASSESSMENT_LIST:
            return {
                getAssessmentLoading: false,
                data: action.getAssessement,
                error: false
            };
        case assessmentsConstants.ASSESSMENT_LIST_ERROR:
            return {
                getAssessmentLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/assessments/getAssessments.reducer.js